import { useTranslation } from 'react-i18next';
import { CircleTickSolid } from '../../assets/icons/Tickbox';
import { brandFriendlyName } from '../../constants/brandCode';
import { useIsTenantFeatureEnabled } from '../../hooks';

const styles = {
  protectionSection: 'w-full bg-(--color-bg-main) py-space-700 px-space-500',
  protectionContent: 'max-w-6xl mx-auto flex flex-col md:flex-row gap-space-600 items-center',
  protectionText: 'flex flex-col gap-space-400 flex-1',
  protectionImage: 'flex-1 overflow-hidden max-w-137.25',
};

type ProtectionProps = {
  brandImage: string;
};

export const Protection = ({ brandImage }: ProtectionProps) => {
  const isProtectionEnabled = useIsTenantFeatureEnabled('protection');

  const { t } = useTranslation('modelSerialLanding', { keyPrefix: 'protection' });

  const benefitsList = t('benefits', { returnObjects: true }) as string[];

  if (!isProtectionEnabled) return null;

  return (
    <div className={styles.protectionSection}>
      <div className={styles.protectionContent}>
        <div className={styles.protectionText}>
          <h2 className="text-h2">{t('header')}</h2>
          <p className="text-body">{t('section')}</p>
          <ul className="flex flex-col gap-space-300">
            {benefitsList?.map((item) => (
              <li key={item} className="flex items-start gap-space-200">
                <CircleTickSolid className="shrink-0 mt-space-100" />
                <span className="text-body">{item}</span>
              </li>
            ))}
          </ul>
          <p className="text-body">{t('body')}</p>
        </div>

        <div className={styles.protectionImage}>
          <img
            src={brandImage}
            alt={`${brandFriendlyName} ${t('alt')}`}
            className="w-full h-auto object-cover"
            width={549}
            height={366}
          />
        </div>
      </div>
    </div>
  );
};
